import { render, staticRenderFns } from "./ApiUser.vue?vue&type=template&id=85b8e9be&scoped=true&"
import script from "./ApiUser.vue?vue&type=script&lang=js&"
export * from "./ApiUser.vue?vue&type=script&lang=js&"
import style0 from "./ApiUser.vue?vue&type=style&index=0&id=85b8e9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b8e9be",
  null
  
)

export default component.exports